import { match } from "minimatch";
import React from "react";
const Matches = () => {
  const matchesdata = require("../services/Matches.json");
  return (
    <>
      <table class="table">
        <thead class="thead-dark">
          <tr>
          <th scope="col">No</th>
            <th scope="col">Matches</th>
            <th scope="col">Venues</th>
            <th scope="col">Date</th>
            <th scope="col">Toss winner</th>
            <th scope="col">Match Winner</th>
            <th scope="col">Match Loser</th>
            <th scope="col">Man of the match</th>
            <th scope="col">Bowler of match</th>
          </tr>
        </thead>
        <tbody>
          {matchesdata.matches.map((val) => (
            <tr>
              <th scope="row">{matchesdata.matches.indexOf(val) + 1}</th>
              <td><b>{val.team1} vs {val.team2}</b></td>
              <td><b>{val.venue}</b></td>
              <td><b>{val.date}</b></td>
              <td><b>{val.tosswinner}</b></td>
              <td><b>{val.winner}</b></td>
              <td><b>{val.looser}</b></td>
              <td><b>{val.manofthematch}</b></td>
              <td><b>{val.bowlerofthematch}</b></td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Matches;
